/**
 * React Component for NewsItem on the home page and club page.
 */
import React from "react";
import { Link } from "react-router-dom";
import ImageContainer from "../core/ImageContainer";

const NewsItem = ({ time, author, filename, newsId, title, last, isSmall, url_override }) => {
  return (
    <Link
      to={url_override ? url_override : `/news/${newsId}`}
      className={`bg-black max-sm:w-full news-item-hover relative overflow-hidden 
        h-52 max-h-52 min-h-52 
        xxs:h-72 xxs:min-h-72 xxs:max-h-72 
        xs:h-[22rem] xs:min-h-[22rem] xs:max-h-[22rem]
        sm:min-h-96 sm:h-96 sm:max-h-96 
        xxs:mx-2 transition-transform transform ${
        last
          ? "max-sm:hidden sm:mr-0 w-1/2"
          : "sm:ml-0 sm:w-1/2"
      }`}
      target={url_override ? "_blank" : ""}
    >
      <div className="news-image-container flex justify-center items-center w-full h-full">
        <div className="news-image w-full h-full relative top-0 left-0">
          <img
              src={filename ? `https://buiha.org.uk/assets/img/resource/${filename}` : "/placeholder2.jpg"}
              alt={title}
              className="h-full w-full object-cover relative top-0 left-0"
          />
          {filename ? null : <img
              src={`https://buiha.org.uk/assets/img/icon/md/${author.toLowerCase()}.png`}
              alt={title}
              className="absolute top-0 left-0 opacity-30"
          />}
        </div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-t via-transparent from-black to-transparent opacity-80"></div>
      <div
          className={`absolute inset-0 flex flex-col justify-end p-2 pr-4 xs:pr-6 xs:p-3 text-content`}
      >
        <p
          className={`max-xxs:hidden text-white text-xs font-light drop-shadow ${
            isSmall ? "hidden" : "block"
          }`}
        >
          Posted {time} ago
        </p>
        <h2
          className={`text-white drop-shadow text-xl text2l xxs:text-2xl font-semibold leading-tight ${
            isSmall ? "text-2xl" : "icons1:text-3xl"
          }`}
        >
          {title}
        </h2>
      </div>
    </Link>
  );
};

export default NewsItem;
